import React, { useState } from "react";

import { useDispatch } from "react-redux";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import { postAPIPayload } from "../../../apis/postApi";
import SecurityPinGeneration from "../../common/SecurityPinGeneration";
import { userProfileAction } from "../../../redux/slices/user/userProfileSlice";

const AdminUnlockPinSetupModal = ({
  open = false,
  userEmail = "",
  onComplete = () => {},
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState({});

  const handleSavePin = async (pin) => {
    setLoading(true);
    setResponse({});
    try {
      const result = await postAPIPayload({
        url: "admin/set-unlock-pin",
        data: {
          admin_unlock_pin: pin,
          admin_unlock_pin_confirmation: pin,
        },
        token: true,
      });
      setResponse(result || {});
      if (result?.success) {
        dispatch(
          userProfileAction.userProfileData({
            url: "profile",
            data: {},
            token: true,
          }),
        );
      }
    } catch {
      setResponse({
        success: false,
        data: { message: "Unable to save admin unlock PIN." },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth disableEscapeKeyDown>
      <DialogTitle>Set your admin unlock PIN</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Before you can unlock customer properties, create a personal 5-digit
          admin unlock PIN. You can change it later from My Profile.
        </Typography>
        <SecurityPinGeneration
          titleText="Create your admin unlock PIN"
          subTitletext="This PIN replaces the old shared override code."
          confirmText="Confirm your admin unlock PIN"
          apiCall={handleSavePin}
          securityPinResponse={response}
          loader={loading}
          userEmail={userEmail}
          onCloseBtnFun={onComplete}
          isTailwindComponent
        />
      </DialogContent>
    </Dialog>
  );
};

export default AdminUnlockPinSetupModal;
